import { render, staticRenderFns } from "./KoLDetail.vue?vue&type=template&id=0d46372f&scoped=true"
import script from "./KoLDetail.vue?vue&type=script&lang=js"
export * from "./KoLDetail.vue?vue&type=script&lang=js"
import style0 from "./KoLDetail.vue?vue&type=style&index=0&id=0d46372f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d46372f",
  null
  
)

export default component.exports